import { render, staticRenderFns } from "./performance.vue?vue&type=template&id=3e495634&scoped=true"
import script from "./performance.vue?vue&type=script&lang=ts"
export * from "./performance.vue?vue&type=script&lang=ts"
import style0 from "./performance.vue?vue&type=style&index=0&id=3e495634&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e495634",
  null
  
)

export default component.exports